"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRecordBridge = startRecordBridge;
const browser_core_1 = require("@datadog/browser-core");
function startRecordBridge(viewHistory) {
    const bridge = (0, browser_core_1.getEventBridge)();
    return {
        addRecord: (record) => {
            // Get the current active view, not at the time of the record, aligning with the segment logic.
            // This approach could potentially associate the record to an incorrect view, in case the record date is in the past (e.g. frustration records).
            // However the risk is minimal. We could address the issue when potential negative impact are identified.
            const view = viewHistory.findView();
            bridge.send('record', record, view.id);
        },
    };
}
//# sourceMappingURL=startRecordBridge.js.map